const url = 'https://kind-pink-anemone-tutu.cyclic.app/getAllProducts'

function getProuduct(setData, setError, setLoading) {
    fetch(url).then(response => {
        if (response.ok) {
            return response.json()
        }
        throw response
    }).then(data => {
        setData(data.products.slice(0, 10))
    }).catch(error => {
        setError(error)
    }).finally(() => {
        setLoading(false)
    })
}

export default getProuduct